(() => {
  'use strict';
  const initialized = new WeakSet();
  const clean = node => (node?.textContent || '').replace(/\s+/g, ' ').trim();
  const labels = new Map([
    ['FABRIC', 'Fabric'], ['SILHOUETTE', 'Silhouette'], ['HEMLINE/TRAIN', 'Length'],
    ['NECKLINE', 'Neckline'], ['SLEEVE LENGTH', 'Sleeves'], ['EMBELLISHMENTS', 'Finishing details'],
    ['BACK DETAILS', 'Back details'], ['WAIST', 'Waistline'], ['VENUES', 'Occasion'], ['SLEEVE STYLE', 'Sleeve style'],
    ['STYLE', 'Style'], ['SEASON', 'Season'], ['DEFAULT COLOR', 'Default colour'], ['TREND COLLECTIONS', 'Collection']
  ]);
  const primaryKeys = ['FABRIC', 'SILHOUETTE', 'HEMLINE/TRAIN', 'NECKLINE', 'SLEEVE LENGTH', 'EMBELLISHMENTS', 'BACK DETAILS', 'WAIST'];
  function addFact(list, key, value) {
    const group = document.createElement('div');
    const label = document.createElement('dt');
    const detail = document.createElement('dd');
    label.textContent = labels.get(key) || key;
    detail.textContent = value;
    group.append(label, detail);
    list.append(group);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('.dress-details').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const description = section.querySelector('.pdp-description');
      const firstTable = description?.querySelector('table');
      const facts = new Map();
      if (firstTable) Array.from(firstTable.rows).forEach(row => {
        if (row.cells.length !== 2) return;
        const key = clean(row.cells[0]).replace(/:$/, '').toUpperCase();
        const value = clean(row.cells[1]);
        if (key && value) facts.set(key, value);
      });
      const list = section.querySelector('[data-dress-facts]');
      primaryKeys.forEach(key => { if (facts.has(key)) addFact(list, key, facts.get(key)); });
      if (list.children.length) {
        section.querySelector('[data-dress-story]').hidden = false;
        const fabric = facts.get('FABRIC');
        const length = facts.get('HEMLINE/TRAIN');
        const shape = facts.get('SILHOUETTE');
        if (fabric && length && shape) {
          const article = /^[aeiou]/i.test(shape) ? 'an' : 'a';
          section.querySelector('[data-dress-intro]').textContent = `This ${length.toLowerCase()} dress pairs ${fabric.toLowerCase()} with ${article} ${shape.toLowerCase()} silhouette.`;
        }
      }
      // Keep the merchant's full description as the no-script / unfamiliar-content
      // fallback and as the source for size charts. Only replace the known layout.
      if (!description || !list.children.length) return;
      const remainder = description.cloneNode(true);
      remainder.querySelector('table')?.remove();
      remainder.querySelectorAll('table.table_all').forEach(table => table.remove());
      remainder.querySelectorAll('img').forEach(img => { if (/\/measure_big_en\.jpg(?:\?|$)/i.test(img.getAttribute('src') || '')) img.remove(); });
      remainder.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(heading => { if (/^size chart\s*\((inch|cm)\)$/i.test(clean(heading))) heading.remove(); });
      const inline = section.querySelector('[data-inline-size-guide]');
      const originalCharts = description.querySelectorAll('table.table_all');
      if (!originalCharts.length) {
        const note = section.querySelector('.dress-measure__note');
        const link = note.querySelector('a');
        link.textContent = 'Ask us about sizing';
        note.replaceChildren(document.createTextNode('Share her measurements with our team for help choosing a size. '), link, document.createTextNode('.'));
      }
      const chartsReady = !originalCharts.length || inline?.querySelectorAll('.size-guide__table').length === originalCharts.length;
      if (clean(remainder) || remainder.querySelector('img,video,iframe,table') || !chartsReady) return;
      const extraFacts = document.createElement('dl');
      extraFacts.className = 'dress-details__extra-facts';
      facts.forEach((value, key) => { if (!primaryKeys.includes(key)) addFact(extraFacts, key, value); });
      const fallback = section.querySelector('[data-original-details]');
      description.hidden = true;
      if (extraFacts.children.length) fallback.append(extraFacts);
      else fallback.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
